export default "__VITE_ASSET__7CcOtxQP__"